module.exports = __webpack_public_path__ + "media/img/pages/companies/zhaw_sml-1ed8209aade49361bb62e6edf9add606.png";